import * as React from "react";
import { Text } from "@uikit";
import { Course_Facilities } from "@kalabo/golfsavers-common";

import Caddies_Icon from "@images/icons/course/caddies.svg";
import ClubHire_Icon from "@images/icons/course/club-hire.svg";
import DrivingRange_Icon from "@images/icons/course/driving_range.svg";
import GolfCart_Icon from "@images/icons/course/golf_cart.svg";
import GolfLessons_Icon from "@images/icons/course/golf_lessons.svg";
import LockerRoom_Icon from "@images/icons/course/locker-room.svg";
import NightGolf_Icon from "@images/icons/course/night_golf.svg";
import OnsiteAccomodation_Icon from "@images/icons/course/onsite-accommodation.svg";
import PracticeGreen_Icon from "@images/icons/course/practice_green.svg";
import ProShop_Icon from "@images/icons/course/pro-shop.svg";
import Restaurant_Icon from "@images/icons/course/restaurant.svg";
import ShoeHire_Icon from "@images/icons/course/shoe-hire.svg";
import Spa_Icon from "@images/icons/course/spa.svg";

interface IProps {
  facilities: Course_Facilities;
}

const CourseFacilities = ({ facilities }: IProps) => {
  if (!facilities) return null;
  let course_facilities = () => {
    return [
      {
        available: facilities.golf_carts === "yes",
        text: "Golf Carts",
        icon: <GolfCart_Icon className="w-5 h-5" />,
      },
      {
        available: facilities.night_golf === "yes",
        text: "Night Golf",
        icon: <NightGolf_Icon className="w-5 h-5" />,
      },
      {
        available: facilities.locker_room === "yes",
        text: "Locker Room",
        icon: <LockerRoom_Icon className="w-5 h-5" />,
      },
      {
        available: facilities.caddies === "yes",
        text: "Caddies",
        icon: <Caddies_Icon className="w-5 h-5" />,
      },
      {
        available: facilities.golf_shop === "yes",
        text: "Pro Shop",
        icon: <ProShop_Icon className="w-5 h-5" />,
      },
      {
        available: facilities.restaurant === "yes",
        text: "Restaurant",
        icon: <Restaurant_Icon className="w-5 h-5" />,
      },
      {
        available: facilities.driving_range === "yes",
        text: "Driving Range",
        icon: <DrivingRange_Icon className="w-5 h-5" />,
      },
      {
        available: facilities.club_rental === "yes",
        text: "Club Hire",
        icon: <ClubHire_Icon className="w-5 h-5" />,
      },
      {
        available: facilities.spa_and_massage === "yes",
        text: "Spa & Massage",
        icon: <Spa_Icon className="w-5 h-5" />,
      },
      {
        available: facilities.practice_green === "yes",
        text: "Practice Green",
        icon: <PracticeGreen_Icon className="w-5 h-5" />,
      },
      {
        available: facilities.shoe_rental === "yes",
        text: "Shoe Hire",
        icon: <ShoeHire_Icon className="w-5 h-5" />,
      },
      {
        available: facilities.onsite_accommodation === "yes",
        text: "Accommodation",
        icon: <OnsiteAccomodation_Icon className="w-5 h-5" />,
      },
      {
        available: facilities.golf_lessons === "yes",
        text: "Golf Lessons",
        icon: <GolfLessons_Icon className="w-5 h-5" />,
      },
    ];
  };
  return (
    <div>
      <Text
        element="h3"
        size={17}
        leading={1.3}
        weight="semibold"
        className="mb-[20px]"
        color="black90"
      >
        Amenities
      </Text>
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-4">
        {course_facilities().map((facility, index) => {
          return (
            <div key={index}>
              <Amenity
                available={facility.available}
                text={facility.text}
                icon={facility.icon}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

interface IDataProps {
  text: string;
  available: boolean;
  icon?: any;
}

const Amenity = ({ available, text, icon }: IDataProps) => {
  return (
    <div
      className={`mb-[10px] gap-2 flex flex-row items-center  ${
        !available && "opacity-50"
      }`}
    >
      {icon}
      <Text
        size={15}
        className={`mt-[1px] mb-0 ${!available && " line-through"}`}
        color={`black90`}
      >
        {text}
      </Text>
    </div>
  );
};

export default CourseFacilities;
